import React from 'react';

export const InputError = ({ message }) => {
    return <small className='p-error'>{message}</small>;
};
